var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-background"},[_c('div',{staticClass:"container",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 col-xl-9"},[_c('FailedLoginContent')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }